// extracted by mini-css-extract-plugin
export default {"body":"ConfirmModal_body__6vcKF"};